import React from 'react';
import { motion } from 'framer-motion';
import { Settings as SettingsIcon, LogOut, X } from 'lucide-react';

const MobileHeader = ({
  activeSection,
  navItems,
  user,
  mobileMenuOpen,
  onMenuToggle,
  onLogout
}) => {
  return (
    <motion.div
      initial={{ y: -50 }}
      animate={{ y: 0 }}
      transition={{ type: "spring", damping: 25 }}
      className="md:hidden fixed top-0 left-0 right-0 z-40 bg-black/95 backdrop-blur-xl border-b border-white/[0.05]"
    >
      <div className="px-4 py-3">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-3">
            <motion.button
              whileTap={{ scale: 0.95 }}
              onClick={onMenuToggle}
              className="p-2 bg-white/[0.02] rounded-md border border-white/[0.05] hover:bg-white/[0.03] transition-all duration-200"
            >
              <motion.div
                animate={{ rotate: mobileMenuOpen ? 180 : 0 }}
                transition={{ duration: 0.3 }}
              >
                {mobileMenuOpen ? (
                  <X className="w-5 h-5 text-white/50" />
                ) : (
                  <SettingsIcon className="w-5 h-5 text-emerald-400/80" />
                )}
              </motion.div>
            </motion.button>
            <div>
              <motion.h1
                key={activeSection}
                initial={{ opacity: 0, x: -20 }}
                animate={{ opacity: 1, x: 0 }}
                className="text-sm font-medium text-white/80"
              >
                {navItems.find(item => item.id === activeSection)?.label || 'Settings'}
              </motion.h1>
            </div>
          </div>
          {user && (
            <motion.button
              whileTap={{ scale: 0.95 }}
              onClick={onLogout}
              className="p-2 text-red-400/70 hover:text-red-400/90 hover:bg-white/[0.02] rounded-md transition-all duration-200"
            >
              <LogOut className="w-5 h-5" />
            </motion.button>
          )}
        </div>
      </div>
    </motion.div>
  );
};

export default MobileHeader;